// Small helpers shared inside the package. Not exported from index.ts.

/** Median beat interval of a beat list, in seconds. */
export function medianInterval(beats: readonly number[]): number {
  const gaps = beats.slice(1).map((b, i) => b - beats[i]!).sort((a, b) => a - b);
  return gaps[gaps.length >> 1]!;
}

/** Modulo with the sign of n, so mod(-1, 8) is 7. */
export function mod(a: number, n: number): number {
  return ((a % n) + n) % n;
}
